(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const drawer = document.querySelector('[data-nav-drawer]');
  const toggle = document.querySelector('[data-nav-open]');
  if (drawer && toggle) {
    const motion = () => window.CJR?.motion;
    const open = () => {
      toggle.setAttribute('aria-expanded', 'true');
      if (motion()) motion().openDrawer(drawer, { side: 'left', items: [...drawer.querySelectorAll('.nav-group__heading, .nav-list > li'), drawer.querySelector('.nav-drawer__close')] });
      else drawer.showModal();
    };
    let closing = false;
    const close = async () => {
      if (closing || !drawer.open) return;
      closing = true;
      drawer.classList.add('is-closing');
      await motion()?.closeDrawer(drawer, { side: 'left', items: [...drawer.querySelectorAll('.nav-group__heading, .nav-list > li'), drawer.querySelector('.nav-drawer__close')] });
      drawer.close();
      drawer.classList.remove('is-closing');
      closing = false;
      toggle.setAttribute('aria-expanded', 'false');
    };
    toggle.addEventListener('click', open);
    drawer.querySelector('[data-nav-close]').addEventListener('click', close);
    drawer.addEventListener('click', async (e) => {
      const link = e.target.closest('a[href]');
      if (e.target === drawer) { close(); return; }
      if (!link) return;
      // plain clicks: the next page's skeleton appears behind the drawer, the full close plays, then navigate;
      // modifier clicks / new tabs keep default behaviour
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || link.target === '_blank') return;
      e.preventDefault();
      window.CJR?.skeleton?.show(link);
      await close();
      window.location.assign(link.href);
    });
    drawer.addEventListener('close', () => toggle.setAttribute('aria-expanded', 'false'));
    drawer.addEventListener('cancel', (e) => { e.preventDefault(); close(); }); // Escape uses the same choreography
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const root = document.querySelector('[data-collection]');
  if (root) {
    const toggle = root.querySelector('[data-filter-toggle]');
    const form = root.querySelector('[data-filter-form]');
    const grid = root.querySelector('[data-collection-grid]');
    const filterItems = () => [...form.querySelectorAll('.filter-group__title, .filter-group__list > li')];
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      toggle.querySelector('[data-filter-toggle-label]').hidden = open;
      toggle.querySelector('[data-filter-toggle-close]').hidden = !open;
      form.inert = !open; // closed: out of the tab order and the accessibility tree while it folds away
      const motion = window.CJR?.motion;
      if (motion) motion.unfold(form, open, { items: filterItems() }); else form.classList.toggle('is-open', open);
    });
    let controller;
    form.addEventListener('change', async () => {
      const params = new URLSearchParams(new FormData(form));
      const url = `${form.action.split('?')[0]}?${params}`;
      controller?.abort();
      controller = new AbortController();
      const request = controller;
      grid.classList.add('is-loading');
      try {
        const html = await fetch(`${url}&section_id=${root.closest('.shopify-section').id.replace('shopify-section-', '')}`, { signal: request.signal }).then((r) => {
          if (!r.ok) throw new Error('Filter request failed');
          return r.text();
        });
        const doc = new DOMParser().parseFromString(html, 'text/html');
        if (request !== controller) return;
        grid.innerHTML = doc.querySelector('[data-collection-grid]').innerHTML;
        // Shopify recalculates counts and disabled values after every selection.
        form.querySelector('.collection__filters-inner').innerHTML = doc.querySelector('.collection__filters-inner').innerHTML;
        history.replaceState({}, '', url);
      } catch (e) {
        if (e.name !== 'AbortError' && request === controller) window.location.assign(url);
      } finally {
        if (request === controller) grid.classList.remove('is-loading');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const section = document.querySelector('[data-product]');
  if (section) {
    const gallery = section.querySelector('[data-product-media]');
    const info = section.querySelector('.product__info');
    const actions = section.querySelector('.product__actions');
    const actionsSlot = section.querySelector('.product__actions-slot');
    const desktopLayout = window.matchMedia('(min-width: 750px)');
    let layoutFrame;
    let visibilityFrame;
    const updateActionVisibility = () => {
      cancelAnimationFrame(visibilityFrame);
      visibilityFrame = requestAnimationFrame(() => {
        const bounds = section.getBoundingClientRect();
        section.classList.toggle('is-product-active', desktopLayout.matches && bounds.top < window.innerHeight && bounds.bottom >= window.innerHeight - 1);
        section.classList.toggle('is-actions-floating', desktopLayout.matches && actionsSlot.getBoundingClientRect().bottom > window.innerHeight);
      });
    };
    window.addEventListener('scroll', updateActionVisibility, { passive: true });
    const measureLayout = () => {
      cancelAnimationFrame(layoutFrame);
      layoutFrame = requestAnimationFrame(() => {
        if (!desktopLayout.matches) {
          section.classList.remove('is-sequential', 'is-product-active', 'is-actions-floating');
          section.style.removeProperty('--product-actions-height');
          section.style.removeProperty('--product-scroll-height');
          section.style.removeProperty('--product-info-top');
          return;
        }
        section.classList.add('is-sequential');
        section.style.setProperty('--product-actions-height', `${actions.getBoundingClientRect().height}px`);
        const viewport = window.innerHeight;
        const infoHeight = info.getBoundingClientRect().height;
        const mediaHeight = gallery.getBoundingClientRect().height;
        const infoOverflow = Math.max(0, infoHeight - viewport);
        section.style.setProperty('--product-scroll-height', `${Math.max(viewport, mediaHeight) + infoOverflow}px`);
        section.style.setProperty('--product-info-top', `${-infoOverflow}px`);
        section.classList.add('is-sequential');
        updateActionVisibility();
      });
    };
    // Recalculate when images/fonts load or an accordion changes the information height.
    const layoutObserver = new ResizeObserver(measureLayout);
    layoutObserver.observe(gallery);
    layoutObserver.observe(info);
    layoutObserver.observe(actions);
    window.addEventListener('resize', measureLayout, { passive: true });
    desktopLayout.addEventListener('change', measureLayout);
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(section)) return;
      layoutObserver.disconnect();
      cancelAnimationFrame(layoutFrame);
      cancelAnimationFrame(visibilityFrame);
      window.removeEventListener('scroll', updateActionVisibility);
      window.removeEventListener('resize', measureLayout);
      desktopLayout.removeEventListener('change', measureLayout);
    });
    measureLayout();

    const variants = JSON.parse(section.querySelector('[data-variants]').textContent);
    const form = section.querySelector('[data-product-form]');
    const idInput = form.querySelector('[data-variant-id]');
    const button = form.querySelector('[data-add-to-cart]');
    const buttonText = form.querySelector('[data-add-to-cart-text]');
    const priceEl = section.querySelector('[data-product-price]');
    const errorEl = form.querySelector('[data-product-error]');
    const money = (cents) => {
      const fmt = window.CJR?.moneyFormat || '$' + '{' + '{amount}}';
      const amount = (cents / 100).toFixed(2);
      const [whole, dec] = amount.split('.');
      return fmt.replace(/\{\{\s*amount\s*\}\}/, `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${dec}`).replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    };

    const selectedOptions = () =>
      [...form.querySelectorAll('[data-option-index]')].map((f) => f.querySelector('input:checked')?.value);

    const update = () => {
      const opts = selectedOptions();
      const variant = variants.find((v) => v.options.every((o, i) => o === opts[i]));
      form.querySelectorAll('[data-option-index]').forEach((f, i) => {
        const label = f.querySelector('[data-option-value-label]');
        if (label) label.textContent = opts[i] || '';
        f.querySelectorAll('.option__input').forEach((input) => {
          const candidate = opts.slice(); candidate[i] = input.value;
          const match = variants.find((v) => v.options.every((o, j) => o === candidate[j]));
          input.nextElementSibling.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
      if (!variant) {
        button.disabled = true; buttonText.textContent = window.CJR?.strings?.unavailable || 'Unavailable'; return;
      }
      const previousVariant = variants.find((v) => String(v.id) === idInput.value);
      idInput.value = variant.id;
      button.disabled = !variant.available;
      buttonText.textContent = variant.available ? (window.CJR?.strings?.addToCart || 'Add to Cart') : (window.CJR?.strings?.soldOut || 'Sold out');
      priceEl.innerHTML = variant.compare_at_price > variant.price
        ? `<s>${money(variant.compare_at_price)}</s> ${money(variant.price)}`
        : money(variant.price);
      const url = new URL(window.location); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      const media = section.querySelector(`[data-media-id="${variant.featured_media?.id}"]`);
      if (media && variant.featured_media && variant.featured_media.id !== previousVariant?.featured_media?.id) {
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        if (desktopLayout.matches) {
          // Explicit color changes may jump to their image; ordinary page scroll keeps info first.
          const infoOverflow = Math.max(0, info.getBoundingClientRect().height - window.innerHeight);
          const productTop = section.getBoundingClientRect().top + window.scrollY;
          const imageOffset = media.getBoundingClientRect().top - gallery.getBoundingClientRect().top;
          window.scrollTo({ top: productTop + infoOverflow + imageOffset, behavior });
        } else {
          gallery.scrollTo({ left: media.offsetLeft - gallery.offsetLeft, behavior });
        }
      }
    };
    form.addEventListener('change', (e) => { if (e.target.matches('.option__input')) update(); });

    // Animated accordions (details elements)
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    section.querySelectorAll('.accordion').forEach((details) => {
      const summary = details.querySelector('.accordion__summary');
      const body = details.querySelector('.accordion__body');
      const motion = window.CJR?.motion;
      if (!summary || !body || reduced || !motion) return;
      details.classList.add('is-animated');
      const items = [...body.querySelector('.accordion__content').children];
      summary.addEventListener('click', async (e) => {
        e.preventDefault();
        const open = !details.classList.contains('is-open');
        details.classList.toggle('is-open', open); // chevron follows the click, not the settled state
        details.open = true; // rendered (folded to 0) so the spring can measure it; closed only once folded
        await motion.unfold(body, open, { items });
        if (!details.classList.contains('is-open')) details.open = false;
      });
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      errorEl.hidden = true;
      button.disabled = true;
      try {
        const res = await fetch(`${window.CJR?.routes?.cart_add_url || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message);
        window.CJR?.motion?.pulse(button);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { open: true } }));
      } catch (err) {
        errorEl.textContent = err.message; errorEl.hidden = false;
      } finally {
        button.disabled = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  // Shopify's reference pattern: fetch the section once it nears the viewport, swap in the rendered markup.
  // Re-run for sections the theme editor re-renders (shopify:section:load), which arrive empty.
  const loadRecommendations = (root) => {
    if (root.querySelector('.recommendations__inner')) return;
    const io = new IntersectionObserver(async (entries) => {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      try {
        const html = await fetch(root.dataset.url).then((r) => (r.ok ? r.text() : ''));
        const inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.recommendations__inner');
        if (inner) root.replaceChildren(inner); // tiles carry data-reveal: motion.js picks them up as they enter view
      } catch (e) { /* no recommendations: the section stays empty */ }
    }, { rootMargin: '0px 0px 200px 0px' });
    io.observe(root);
  };
  document.querySelectorAll('[data-recommendations]').forEach(loadRecommendations);
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-recommendations]').forEach(loadRecommendations));

  } catch(e) { console.error(e); }
})();
})();
